<template>
  <c-app :sider-open="$root.siderOpen">
    <c-sider>
      <c-brand class="u-bg-primary" slot="start">
        Competition Labs
      </c-brand>
      <Navigation />
    </c-sider>
    <c-content>
      <c-header>
        <Navbar />
      </c-header>
      <c-body>
        <transition name="slide-fade" mode="out-in">
            <router-view></router-view>
        </transition>
      </c-body>
      <c-footer>
      </c-footer>
    </c-content>
  </c-app>
</template>
<script>
import Navigation from '../../components/Navigation';
import Navbar from '../../components/Navbar';
import config from '../../config';
import axios from 'axios'

export default {
    components: {
        Navigation,
        Navbar
    },
    created() {
      
      
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}

/* Анимации появления и исчезновения могут иметь */
/* различные продолжительности и динамику.       */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.u-bg-primary{
  color: #fff;
  font-size: 14px;
}
</style>